import getMilestonePlanningSummary from "../Milestones/getMilestonePlanningSummary";

const getSimplifiedPlanningSummary = (milestone, initiative) => {
  // Helper function to get date at UTC midnight
  const getUTCMidnight = (date) => {
    if (!date) return null;
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0, 0, 0, 0
    ));
  };

  // Get current date at UTC midnight
  const now = new Date();
  const currentDate = getUTCMidnight(now);
  const startDate = milestone.startDate ? getUTCMidnight(new Date(milestone.startDate)) : null;
  const endDate = milestone.endDate ? getUTCMidnight(new Date(milestone.endDate)) : null;

  const msInDay = 24 * 60 * 60 * 1000;
  const daysUntilStart = startDate ? Math.ceil((startDate.getTime() - currentDate.getTime()) / msInDay) : null;
  const daysUntilEnd = endDate ? Math.ceil((endDate.getTime() - currentDate.getTime()) / msInDay) : null;

  // For Not Started milestones
  if (milestone.status === 'Not Started' && startDate && endDate) {
    // FIRST: Check if end date has passed -> Late (Late to Finish)
    if (currentDate > endDate) {
      return 'Late';
    }

    // SECOND: Check if start date has passed but end date hasn't -> Late to start
    if (currentDate > startDate && currentDate < endDate) {
      return 'Late to start';
    }

    // THIRD: Check if start date is within 30 days (Due Soon)
    if (daysUntilStart !== null && daysUntilStart <= 30) {
      if (daysUntilStart <= 7) {
        return 'Due soon';
      }
      return 'Due soon for 30 days';
    }

    // FOURTH: Start date is more than 30 days in future
    if (daysUntilStart > 30) {
      return 'On plan';
    }
  }

  // For Started milestones, check based on end date
  if (milestone.status === 'Started' && endDate) {
    // FIRST: Check if end date has passed -> Late (Late to Finish)
    if (currentDate > endDate) {
      return 'Late';
    }

    // SECOND: Check if end date is within 30 days (Due Soon takes priority)
    if (daysUntilEnd !== null && daysUntilEnd <= 30) {
      if (daysUntilEnd <= 7) {
        return 'Due soon';
      }
      return 'Due soon for 30 days';
    }

    // THIRD: If end date is more than 30 days away, check the detailed summary for Lately Started
    const detailedSummary = getMilestonePlanningSummary(milestone, initiative);
    if (detailedSummary && detailedSummary.includes('Lately Started')) {
      return 'Lately Started';
    }
    return 'On plan';
  }

  // For Completed milestones
  if (milestone.status === 'Completed') {
    const detailedSummary = getMilestonePlanningSummary(milestone, initiative);
    if (detailedSummary && detailedSummary.includes('Lately Completed')) {
      return 'Lately Completed';
    }
    return 'Completed';
  }

  // For Cancelled milestones
  if (milestone.status === 'Cancelled') {
    return 'Cancelled';
  }

  // Get the detailed summary for other cases
  const detailedSummary = getMilestonePlanningSummary(milestone, initiative);

  // Extract base category from detailed summary
  let simplifiedStatus = detailedSummary;
  if (detailedSummary) {
    if (detailedSummary.includes(' - ')) {
      simplifiedStatus = detailedSummary.split(' - ')[0];
    } else if (detailedSummary.includes(' (')) {
      simplifiedStatus = detailedSummary.split(' (')[0];
    }
  }

  // Map other categories
  const simplifiedMap = {
    'Cancelled': 'Cancelled',
    'Completed': 'Completed',
    'Lately Completed': 'Lately Completed',
    'Late to Finish': 'Late',
    'Late to Start': 'Late to start',
    'Lately Started': 'Lately Started',
    'On Plan': 'On plan',
    'Due soon': 'Due soon',
    'Due soon for 30 days': 'Due soon for 30 days',
    '<not set>': '<not set>'
  };

  return simplifiedMap[simplifiedStatus] || simplifiedStatus || '<not set>';
};

export default getSimplifiedPlanningSummary;